import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { usePageviewTracking } from "./hooks/usePageviewTracking";

import SplashPage from "./pages/SplashPage";
import Index from "./pages/Index";
import { ReceiptPage } from "./pages/ReceiptPage";
import { InvoicePage } from "./pages/InvoicePage";
import { MerchantDirectoryPage } from "./pages/MerchantDirectoryPage";
import { BrochurePage } from "./pages/BrochurePage";
import { StampClaimPage } from "./pages/StampClaimPage";
import { PusdPocPage } from "./pages/PusdPocPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";
import { AnalyticsRoot } from "./pages/AnalyticsPage";

/** Fires page-view analytics on every route change. Rendered inside the Router. */
function PageviewTracker() {
  usePageviewTracking();
  return null;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageviewTracker />
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/app" element={<Index />} />
        {/* Receipt & invoice pages — must be above /:nip19 catch-all */}
        <Route path="/receipt" element={<ReceiptPage />} />
        <Route path="/invoice" element={<InvoicePage />} />
        <Route path="/merchants" element={<MerchantDirectoryPage />} />
        <Route path="/brochure" element={<BrochurePage />} />
        <Route path="/stamp/:id" element={<StampClaimPage />} />
        {/* Private analytics dashboard (requires stats token) */}
        <Route path="/analytics" element={<AnalyticsRoot />} />
        {/* Stablecoin (PUSD) acceptance — proof of concept */}
        <Route path="/pusd-poc" element={<PusdPocPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
